import { legacyTheme } from '~/legacyTheme';

export const useSxStyles = () => {
  return {
    addDiv: {
      height: '28px',
      padding: '6px',
      fontSize: '14px',
      '&:hover': {
        backgroundColor: '#d0d0d7',
        cursor: 'pointer',
      },
    },
    button: {
      float: 'right',
      marginRight: '8px',
    },
    buttonIcon: {
      margin: '2px 2px 2px 4px',
      display: 'inline',
    },
    buttonText: {
      margin: '2px 4px 2px 2px',
    },
    collapseDiv: {
      border: 'solid 1px #ddd',
      backgroundColor: '#fff',
      borderRadius: '5px',
      width: '245px',
      zIndex: 10000,
      position: 'absolute',
      left: '766px',
      marginTop: '6px',
      boxShadow: '0 6px 12px rgb(0 0 0 / 18%)',
    },
    header: {
      width: '1138px',
      color: legacyTheme.palette.primary.main,
    },
    title: {
      fontWeight: 'bold',
      fontSize: '15px',
      paddingLeft: '12px',
      margin: '0',
      color: legacyTheme.palette.primary.main,
    },
    table: {
      width: '1138px',
    },
    td: {
      fontSize: '13px',
    },
    tooltip: {
      padding: 0,
      border: '1px solid rgba(0, 0, 0, .15)',
      boxShadow: '0 6px 12px rgb(0 0 0 / 18%)',
      margin: 0,
      backgroundColor: '#fff',
      color: '#333',
    },
  };
};
